import React from 'react';
import {
  IonIcon,
  IonLabel,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonRouterOutlet
} from '@ionic/react';
import { document, book } from 'ionicons/icons';
import { connect } from 'react-redux'
//import './Guide.css';

import { Route, Redirect } from "react-router";

import Guide from './Guide';
import Material from './Material';

interface Props {
}

interface ClassState {
  data: any;
  match: any;
}

class Tasks extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  render() {
    const { child, evi } = this.state.match.params;
    return (
      <IonTabs>
        <IonRouterOutlet>
          <Route path="/progress/:child/pro/:evi/guide" component={Guide}  />
          <Route path="/progress/:child/pro/:evi/material" component={Material} />
          <Route path="/" render={() => <Redirect to="/progress/:child/pro" />} exact={true} /> 
        </IonRouterOutlet>

        <IonTabBar slot="bottom" style={{ overflowX: 'auto' }}>
          <IonTabButton tab="progress/pro/guide" href={`/progress/${ child }/pro/${ evi }/guide`}>
            <IonIcon icon={book} />
            <IonLabel>Guias de Estudio</IonLabel>
          </IonTabButton>
          <IonTabButton tab="progress/pro/material" href={`/progress/${ child }/pro/${ evi }/material`}>
            <IonIcon icon={document} />
            <IonLabel>Material Complementario</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Tasks);
